class RelocationEnum {
  static UNKNOWN = 'unknown';
  static AVAILABLE = 'available';
  static UNAVAILABLE = 'unavailable';
}

export default RelocationEnum;
